import Cookies from "universal-cookie";
import CerrarSesion from "./CerrarSesion";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import * as AiIcons from "react-icons/ai";

export const SidebarDirector = () => {
  const cookies = new Cookies();

  // 👇 Aseguramos valores correctos
  const nombre = cookies.get("Nombre") || "Cargando...";
  const hash = cookies.get("hash") || "";

  // 👇 SIEMPRE retorna un array (evita errores de .map)
  return [
    {
      title: (
        <span style={{ fontSize: "18px", fontWeight: "bold" }}>{nombre}</span>
      ),
      icon: <IoIcons.IoIosPerson />,
    },
    {
      title: "Solicitudes",
      path: `/SolicitudesDirector/${hash}sasas`,
      icon: <IoIcons.IoIosPaper />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
    },
    {
      title: "Indicadores",
      path: "/Indicadores",
      icon: <IoIcons.IoMdList />,
    },
    {
      title: "OM Gestionadas",
      path: "/OmNoAgrupadas",
      icon: <IoIcons.IoIosRocket />,
    },
    {
      title: "OM Solucionadas",
      path: "/OMsolucionada",
      icon: <IoIcons.IoIosRocket />,
    },
    {
      title: "Repositorios",
      icon: <AiIcons.AiFillHome />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      subNav: [
        {
          title: "Repositorio de Información",
          path: "/InfoRepositorio",
          icon: <IoIcons.IoMdRecording />,
        },
        {
          title: "Repositorio de Fichas técnicas",
          path: "/RepositorioFichas",
          icon: <IoIcons.IoMdPeople />,
        },
      ],
    },
    {
      title: "",
      path: "/",
      icon: <CerrarSesion />,
    },
  ];
};
